/*
 * -----------------------------------------------------------------------------
 * @cam/details-accordion
 * -----------------------------------------------------------------------------
 * @version 0.0.4
 * @overview Details element progressive enhancments.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/

if (customElements.get('details-accordion') === undefined) {
  class DetailsAccordion extends HTMLElement {
    constructor() {
      super();

      this.accordion = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.disclosure = Array.prototype.slice.call(this.accordion.children).find(element => element != this.summary);

      this.transitioning = false;
      this.accordion.style.overflow = 'hidden';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.transitionDuration = this.reducedMotion ? 0 : Number(this.getAttribute('data-transition-duration'));

      this.summary.addEventListener('click', this.toggle.bind(this));
    }

    toggle(event) {
      event.preventDefault();
      if (this.transitioning) return;
      if (this.accordion.open) { this.close(); return; };
      this.open();
    }

    open() {
      this.transitioning = true;
      this.accordion.open = true;

      this.disclosure.style.height = `${this.disclosure.offsetHeight}px`;
      this.animation = this.disclosure.animate({ height: [0, this.disclosure.offsetHeight] }, { duration: this.transitionDuration, easing: 'ease-out' });

      this.animation.onfinish = () => {
        this.transitioning = false;
        this.disclosure.removeAttribute('style');
      };
    }

    close() {
      this.transitioning = true;

      this.disclosure.style.height = `${this.disclosure.offsetHeight}px`;
      this.animation = this.disclosure.animate({ height: [this.disclosure.offsetHeight, 0] }, { duration: this.transitionDuration, easing: 'ease-out' });

      this.animation.onfinish = () => {
        this.accordion.open = false;
        this.transitioning = false;
        this.disclosure.removeAttribute('style');
      }
    }
  }

  customElements.define('details-accordion', DetailsAccordion);
}
